module.exports = __webpack_public_path__ + "media/images/app/favicon-922c9a99cb42b87a44055fcbb0598591.webp";